<ngx-ui-loader [loaderId]="'initializerLoader'"></ngx-ui-loader>